// src/components/RequireRole.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext'; // ajusta ruta si es distinto

export default function RequireRole({ allow = ['admin'], children }) {
  const { user } = useAuth();

  // No logueado → redirigir al login
  if (!user) return <Navigate to="/login" replace />;

  // Logueado pero sin rol permitido → redirigir a NotFound
  if (!allow.includes(user.rol)) return <Navigate to="/notfound" replace />;

  // Logueado y con rol permitido → mostrar la ruta
  return children;
}
